if (!customElements.get('scrolling-banner')) {
  customElements.define(
    'scrolling-banner',
    class ScrollingBanner extends HTMLElement {
      constructor() {
        super();
        this.setDefaultStyle();
        this.list = this.querySelector('ul');
        this.items = this.list.innerHTML;
        this.fillBanner();
        this.setAnimation();
        window.addEventListener('resize', () => {
          this.reload();
        });
      }

      setDefaultStyle() {
        this.style.display = 'flex';
        this.style.flexWrap = 'nowrap';
        this.style.position = 'relative'
      }

      setAnimation() {
        this.list.classList.add('animate-scroll-text');
      }

      removeAnimation() {
        this.list.classList.remove('animate-scroll-text');
      }

      reload() {
        this.removeAnimation();
        this.list.innerHTML = this.items;
        this.fillBanner();
        this.setAnimation();
      }

      fillBanner() {
        const style = getComputedStyle(this);
        const screenWidth = parseFloat(style.width);
        while (this.calcListWidth() < (screenWidth * 2)) {
          this.list.innerHTML += this.items;
        }
        this.list.style.width = `${this.calcListWidth()}px`;
      }

      calcListWidth() {
        const clone = this.list.cloneNode(true);
        Object.assign(clone.style, {
          overflow: 'visible',
          height: 'auto',
          opacity: '0',
          visibility: 'hidden',
          width: 'max-content'
        });
        this.after(clone);
        const width = clone.offsetWidth;
        clone.remove();
        return width;
      }
    }
  )
}